import {
    FETCH_SEARCH_DATA_USERS_FAILURE,
    FETCH_SEARCH_DATA_USERS_REQUEST,
    FETCH_SEARCH_DATA_USERS_SUCCESS
} from '../../actions/users/search-user-action';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const CLEAR_DATA = "CLEAR_DATA";
const SearchUserReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_SEARCH_DATA_USERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_SEARCH_DATA_USERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                user: action.payload,
            };
        case FETCH_SEARCH_DATA_USERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};


export default SearchUserReducer;